import { BUCKET_PREFIX, ENVIRONMENT } from '../../utils/environment';

import type { TocRiveSlot, TournamentOfChampions } from './types';

const TOC_RIVES_BASE = `${BUCKET_PREFIX}${ENVIRONMENT}/assets/tournament-champions-animations/`;
export const TOC_BANNER_RIV = `${TOC_RIVES_BASE}toc_banner_and_topbar_v8.riv`;
const RIV_FILE_NAME = /^[A-Za-z0-9._-]+\.riv$/;

function isHttpsRivUrl(value: string): boolean {
  if (!value.startsWith('https://')) return false;
  try {
    return new URL(value).pathname.endsWith('.riv');
  } catch {
    return false;
  }
}

// One ToC `rives` entry as a URL: a file name goes under the bucket base, an https .riv URL as-is.
export function tocRiveUrl(rives: unknown, slot: TocRiveSlot): string | null {
  if (!rives || typeof rives !== 'object') return null;
  const value = (rives as Partial<Record<TocRiveSlot, unknown>>)[slot];
  if (typeof value !== 'string') return null;
  if (RIV_FILE_NAME.test(value)) return `${TOC_RIVES_BASE}${value}`;
  return isHttpsRivUrl(value) ? value : null;
}

/**
 * The leaderboard banner / top-bar Rive file: the ToC's `assets.rives.banner`, else the bundled default.
 * Shared by the banner and the store's preloader so both hit the same rive-file cache key.
 */
export function resolveTocBannerRiveUrl(
  assets: TournamentOfChampions['assets'] | undefined,
  failedUrls?: Pick<ReadonlySet<string>, 'has'>,
): string {
  const url = tocRiveUrl(assets?.rives, 'banner') ?? TOC_BANNER_RIV;
  // A file that failed to load falls back to the bundled default.
  return failedUrls?.has(url) ? TOC_BANNER_RIV : url;
}
